<template>
  <el-container
    class="container"
    style="align-items: center"
  >
    <el-col
      :xs="22"
      :sm="20"
      :md="18"
      :lg="16"
      :xl="14"
      :span="12"
    >
      <el-col
        class="left"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="12"
      >
        <div class="logo-wrapper">
          <img
            src="../assets/logo-tesoreria.png"
            class="logo"
          >
        </div>
        <p class="title">
          DESCUENTOS ESPECIALES
        </p>
        <p class="subtitle">
          Tercera edad
        </p>
        <ul>
          <li>
            <p class="content">
              <b>Credencial para votar con fotografía vigente.</b> Que coincida con el domicilio del
              predio por el que se solicita el descuento.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Recibo del último pago predial.</b> Si no cuenta con el recibo, presentar número de
              cuenta predial o clave catastral.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Comprobante de domicilio oficial.</b> Que no sea mayor a tres meses y se presenta
              sólo si se omitió el domicilio en la credencial del INE.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Contribuyentes que no tengan la nacionalidad mexicana.</b> Deberán presentar
              identificación con fotografía, documento oficial expedido por la Secretaría de
              Relaciones Exteriores que ampare la legal estancia en el país y comprobante de
              domicilio.
            </p>
          </li>
        </ul>
        <p class="subtitle" style="margin-top: 30px;">
          Pensionados o jubilados
        </p>
        <ul>
          <li>
            <p class="content">
              <b>Credencial para votar con fotografía vigente.</b> Que coincida con el domicilio del
              predio por el que se solicita el descuento.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Recibo del último pago predial.</b> Si no cuenta con el recibo, presentar número de
              cuenta predial o clave catastral.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Comprobante de domicilio oficial.</b> Que no sea mayor a tres meses y se presenta
              sólo si se omitió el domicilio en la credencial del INE.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Contribuyentes que no tengan la nacionalidad mexicana.</b> Deberán presentar
              identificación con fotografía, documento oficial expedido por la Secretaría de
              Relaciones Exteriores que ampare la legal estancia en el país y comprobante de
              domicilio.
            </p>
          </li>
        </ul>
        <p class="subtitle" style="margin-top: 30px;">
          Viudez
        </p>
        <ul style="page-break-after: always;">
          <li>
            <p class="content">
              <b>Credencial para votar con fotografía vigente.</b> Que coincida con el domicilio del
              predio por el que se solicita el descuento.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Recibo del último pago predial.</b> Si no cuenta con el recibo, presentar número de
              cuenta predial o clave catastral.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Comprobante de domicilio oficial.</b> Que no sea mayor a tres meses y se presenta
              sólo si se omitió el domicilio en la credencial del INE.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Contribuyentes que no tengan la nacionalidad mexicana.</b> Deberán presentar
              identificación con fotografía, documento oficial expedido por la Secretaría de
              Relaciones Exteriores que ampare la legal estancia en el país y comprobante de
              domicilio.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Acta de matrimonio</b>
            </p>
          </li>
          <li>
            <p class="content">
              <b>Acta de defunción del cónyuge</b>
            </p>
          </li>
        </ul>
        <p class="subtitle" style="margin-top: 30px;">
          Discapacitados
        </p>
        <ul>
          <li>
            <p class="content">
              <b>Credencial para votar con fotografía vigente.</b> Que coincida con el domicilio del
              predio por el que se solicita el descuento.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Recibo del último pago predial.</b> Si no cuenta con el recibo, presentar número de
              cuenta predial o clave catastral.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Comprobante de domicilio oficial.</b> Que no sea mayor a tres meses y se presenta
              sólo si se omitió el domicilio en la credencial del INE.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Contribuyentes que no tengan la nacionalidad mexicana.</b> Deberán presentar
              identificación con fotografía, documento oficial expedido por la Secretaría de
              Relaciones Exteriores que ampare la legal estancia en el país y comprobante de
              domicilio.
            </p>
          </li>
          <li>
            <p class="content">
              <b>Credencial nacional para personas con discapacidad</b> emitida por  el sistema
              nacional  para el desarrollo integral de la familia (DIF) o constancia o certificado
              médico expedido por alguna institución pública de salud o de seguridad social, en
              original y copia.
            </p>
          </li>
        </ul>
        <br>
        <br>
      </el-col>
      <el-col
        class="right"
        :xs="22"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="12"
      >
        <img
          src="../assets/logo-tesoreria.png"
          class="logo"
        >
        <div class="buttons">
          <router-link to="/busqueda-del-predio">
            <el-button class="local">
              Consultar predial
            </el-button>
          </router-link>
          <a
            v-if="!$isWebView()"
            target="_blank"
            href="https://www.zapopan.gob.mx/v3/predial/oficinas-recaudadoras-municipales"
          >
            <el-button class="extern">
              Ubicación de las recaudadoras
            </el-button>
          </a>
          <a
            v-if="!$isWebView()"
            target="_blank"
            href="https://www.zapopan.gob.mx/v3/predial/recaudadoras-moviles"
          >
            <el-button class="extern">
              Calendario de recaudadoras móviles
            </el-button>
          </a>
          <router-link to="" v-if="!$isWebView()">
            <el-button class="local" @click="print">
              Imprimir
            </el-button>
          </router-link>
        </div>
        <img
          class="payment-print-badge" src="../assets/payment-print-badge.png"
        >
      </el-col>
    </el-col>
    <el-footer class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col
          :xs="22"
          :sm="21"
          :md="20"
          :lg="19"
          :xl="18"
        >
          <div class="banner">
            <img src="../assets/images/footer-image.png" alt="banner footer">
          </div>
        </el-col>
      </el-row>
      <br>
      <br>
      <br>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  methods: {
    /**
     * Abre la ventana de impresión en PDF del navegador.
     */
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  *{
    font-family: Tahoma;
  }
  .left {
    p {
      text-align: left;
    }
    .logo-wrapper {
      width: 100%;
      text-align: right;
      .logo {
        height: 120px;
        display: none;
      }
    }
    .title, .subtitle {
      padding-left: 40px;
    }
    .title {
      color: #330066;
      font-size: 16pt;
      font-weight: bold;
    }
    .subtitle {
      color: #330066;
      font-size: 14pt;
      font-weight: bold;
    }
    .content {
      color: Black;
      font-family: Arial;
      font-size: 12pt;
      position: relative;
      text-align: justify;
      &::before {
        position: absolute;
        left: -25px;
        top: 4px;
        border: #956fa8 solid 4px;
        border-radius: 50%;
        width: 6px;
        height: 6px;
        content: '';
      }
    }
    li {
      align-self: left;
      margin-top: 5px;
      list-style-type: none;
    }
  }
  .right {
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    padding: 100px 20px 20px;
    .logo {
      height: 120px;
      align-self: flex-start;
    }
    .buttons {
      align-self: center;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .extern, .local {
        width: 100%;
        color: #FFFFFF;
        font-weight: bold;
      }
      .extern {
        background-color: #666666;
      }
      .local {
        background-color: #B9A5CB;
      }
      a {
        width: 100%;
        margin: 8px 0;
      }
    }
    .payment-print-badge {
      margin-top: 100px;
    }
  }
  .el-footer {
    height: auto !important;
    .banner {
      width: 100%;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .payment-print-badge {
    margin-top: 50px !important;
  }
  .right {
    padding-top: 50px !important;
  }
}
@media print {
  .container {
    width: 100%!important;
    .left {
      margin-left: -50%;
      padding-left: 30px;
      margin-top: 20px;
      width: 150%!important;
      .subtitle {
        margin: 8px 0 !important;
      }
      .logo-wrapper {
        .logo {
          display: block;
          position: absolute;
          right: 25px;
          top: 15px;
        }
      }
    }
    .right {
      display: none;
    }
  }
}
</style>

<style lang="scss">
 @media print {
  .header {
    display: none !important;
  }
 }
</style>
